import { Record } from "immutable";

import createFromJS from "../../../createFromJS";

export const LocalUndoMomentRecord = Record({
  value: "",
  selection: null // will be TextSelectionRecord for text, but may be other things
});

createFromJS.registerCallback("LocalUndoMomentRecord", createFromJS.createPrimitiveCallback(LocalUndoMomentRecord));
